import { z } from 'zod';

export type ColorMode = 'light' | 'dark';

// Default colors
const DEFAULT_COLORS = {
	primary: '#ffbf00',
	primaryForeground: '#ffffff',
	secondary: '#e3e1de',
	secondaryForeground: '#374151',
	background: '#f8fafc',
	foreground: '#212529',
	destructive: '#dc2626',
	destructiveForeground: '#ffffff',
	info: '#0ea5e9',
	infoForeground: '#ffffff',
	layout: '#1a1d23',
	layoutForeground: '#ffffff'
};

export const brandingSchema = z.object({
	primary: z
		.string({ message: 'Primary color is required' })
		.min(1, 'Primary color is required')
		.default(DEFAULT_COLORS.primary),
	primaryForeground: z
		.string({ message: 'Primary color text is required' })
		.min(1, 'Primary color text is required')
		.default(DEFAULT_COLORS.primaryForeground),
	secondary: z
		.string({ message: 'Secondary color is required' })
		.min(1, 'Secondary color is required')
		.default(DEFAULT_COLORS.secondary),
	secondaryForeground: z
		.string({ message: 'Secondary color text is required' })
		.min(1, 'Secondary color text is required')
		.default(DEFAULT_COLORS.secondaryForeground),
	info: z.string({ message: 'Info color is required' }).min(1, 'Info color is required').default(DEFAULT_COLORS.info),
	infoForeground: z
		.string({ message: 'Info color text is required' })
		.min(1, 'Info color text is required')
		.default(DEFAULT_COLORS.infoForeground),
	destructive: z
		.string({ message: 'Error color is required' })
		.min(1, 'Error color is required')
		.default(DEFAULT_COLORS.destructive),
	destructiveForeground: z
		.string({ message: 'Error color text is required' })
		.min(1, 'Error color text is required')
		.default(DEFAULT_COLORS.destructiveForeground),
	background: z
		.string({ message: 'Background color is required' })
		.min(1, 'Background color is required')
		.default(DEFAULT_COLORS.background),
	foreground: z
		.string({ message: 'Text color is required' })
		.min(1, 'Foreground color is required')
		.default(DEFAULT_COLORS.foreground),
	layout: z
		.string({ message: 'Layout color is required' })
		.min(1, 'Layout color is required')
		.default(DEFAULT_COLORS.layout),
	layoutForeground: z
		.string({ message: 'Layout color text is required' })
		.min(1, 'Layout color text is required')
		.default(DEFAULT_COLORS.layoutForeground)
});

export const brandingFormSchema = z.object({
	currentColorMode: z.enum(['light', 'dark']).default('light'),
	light: brandingSchema,
	dark: brandingSchema,
	logoAssignmentId: z.string().optional().nullable()
});

export { DEFAULT_COLORS };
